import useSWR from 'swr';
import { get } from '@/lib/api';
import { Skeleton } from '@/components/ui/skeleton';

type Admin = {
  id: string;
  name?: string;
  email?: string;
  collectionId?: string;
  collectionUrl?: string;
};
type Payload = { admins: Admin[] };

export default function Configuration() {
  const { data, isLoading } = useSWR<Payload>('/api/configuration', get);

  return (
    <div className="px-7 py-6">
      <h1 className="text-[20px] font-semibold tracking-tighter">Configuration</h1>
      <p className="mb-4 text-[12px] text-muted">
        Authorized admins · {data?.admins.length ?? 0} accounts
      </p>

      <div className="rounded-md bg-surface shadow-card">
        {isLoading ? (
          <div className="space-y-2 p-3">
            <Skeleton className="h-7 w-full" />
            <Skeleton className="h-7 w-full" />
          </div>
        ) : data?.admins.length ? (
          data.admins.map((a) => (
            <div key={a.id} className="flex items-center gap-3 border-b border-divider px-3 py-2 last:border-b-0">
              <span className="font-mono text-[10px] text-subtle w-24 shrink-0 truncate">{a.id}</span>
              <span className="flex-1 truncate text-[12px]">
                {a.name || '—'}
                {a.email && <span className="ml-2 font-mono text-[11px] text-muted">{a.email}</span>}
              </span>
              {a.collectionUrl ? (
                <a href={a.collectionUrl} target="_blank" rel="noopener noreferrer" className="text-[11px] text-primary hover:underline">
                  collection ↗
                </a>
              ) : a.collectionId ? (
                <span className="font-mono text-[11px] text-muted">{a.collectionId}</span>
              ) : null}
            </div>
          ))
        ) : (
          <div className="p-8 text-center text-[12px] text-muted">No admins configured.</div>
        )}
      </div>
    </div>
  );
}
